import { render, staticRenderFns } from "./Siniestros.vue?vue&type=template&id=3513aba9&"
import script from "./Siniestros.vue?vue&type=script&lang=js&"
export * from "./Siniestros.vue?vue&type=script&lang=js&"
import style0 from "./Siniestros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports